import React, { useState, useEffect } from 'react';
import {
    Card,
    CardBody,
    Button,
    Input,
    Row,
    Col,
} from 'reactstrap';
import {
    Colxx,
    Separator,
} from '../../../../../../components/common/CustomBootstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import { API_outlook } from '../../../../../../constants/APIs';

export default function Subscriptions({
    integrationId,
    saveIntegration,
    existingSubscriptions = [],
    channelDetails = {},
}) {
    const [subscriptions, setSubscriptions] = useState(channelDetails.emails || []);
    const [loadingSubscriptionId, setLoadingSubscriptionId] = useState(null);

    // Get settings from channelDetails
    const settings = channelDetails?.settings || channelDetails?.outlookSettings || {};
    const { clientId, clientSecret, tenantId } = settings;

    useEffect(() => {
        if (existingSubscriptions && existingSubscriptions.length > 0) {
            setSubscriptions([...existingSubscriptions]);
        }
    }, [existingSubscriptions]);

    const handleToggleEnabled = async (index) => {
        const subscription = subscriptions[index];
        const newEnableWebhooks = !subscription.enableWebhooks;
        const updatedSubscriptions = [...subscriptions];
        // Set loading for this row
        setLoadingSubscriptionId(index);

        try {
            if (newEnableWebhooks) {
                // POST - Create webhook subscription
                await AxiosAPI({
                    method: 'post',
                    url: `${API_outlook}`,
                    data: {
                        iid: integrationId,
                        groupId: getGroupID(),
                        email: subscription.email,
                        tenantId: settings?.tenantId,
                        clientId: settings?.clientId,
                        clientSecret: settings?.clientSecret,
                        extendMinutes: 4230,
                    },
                }).then((response) => {
                    updatedSubscriptions[index].subscriptionId = response.data.id;
                });
                NotificationManager.success('Webhook subscription created', 'Success', 3000);
            } else {
                // DELETE - Delete webhook subscription
                await AxiosAPI({
                    method: 'delete',
                    url: `${API_outlook}`,
                    data: {
                        subscriptionId: subscription.subscriptionId || subscription.id,
                        iid: integrationId,
                        groupId: getGroupID(),
                        email: subscription.email,
                        tenantId: settings?.tenantId,
                        clientId: settings?.clientId,
                        clientSecret: settings?.clientSecret,
                        extendMinutes: 43200,
                    },
                }).then(() => {
                    updatedSubscriptions[index].subscriptionId = '';
                });
                NotificationManager.success('Webhook subscription deleted', 'Success', 3000);
            }

            // Update local state immediately

            updatedSubscriptions[index].enableWebhooks = newEnableWebhooks;
            console.log(updatedSubscriptions, 'updatedSubscriptions');
            setSubscriptions(updatedSubscriptions);
        } catch (error) {
            console.error('Error toggling webhook:', error);
            // Revert on error
            const revertedSubscriptions = [...subscriptions];
            revertedSubscriptions[index].enableWebhooks = !newEnableWebhooks;
            setSubscriptions(revertedSubscriptions);
            NotificationManager.error('Failed to update webhook subscription', 'Error', 3000);
        } finally {
            setLoadingSubscriptionId(null);
        }
    };

    const handleAddSubscription = () => {
        setSubscriptions([
            ...subscriptions,
            { email: '', enableWebhooks: false },
        ]);
    };

    const handleEmailChange = (index, value) => {
        const updatedSubscriptions = [...subscriptions];
        updatedSubscriptions[index].email = value;
        setSubscriptions(updatedSubscriptions);
    };

    const handleRemoveSubscription = (index) => {
        const updatedSubscriptions = subscriptions.filter((_, i) => i !== index);
        setSubscriptions(updatedSubscriptions);
    };

    const handleSave = async () => {
        let detailts = channelDetails || {};
        detailts.emails = subscriptions;
        saveIntegration({ channelDetails: detailts });
    };

    return (
        <Card className="mb-4">
            <CardBody>
                <div className="text-center mb-2">
                    <h6>Email Subscriptions</h6>
                </div>
                <Separator className="mb-3" />
                <Card className="p-4 m-4">
                    {subscriptions.map((subscription, index) => (
                        <Row key={index} className="mb-3 align-items-center">
                            <Col md={9}>
                                <Input
                                    type="text"
                                    placeholder="Enter email address"
                                    value={subscription.email}
                                    onChange={(e) => handleEmailChange(index, e.target.value)}
                                />
                            </Col>
                            <Col md={2} className="text-center px-0">
                                {loadingSubscriptionId === index ? (
                                    <span className="loading-spinner">...</span>
                                ) : (
                                    <Switch
                                        className="custom-switch-primary custom-switch-small"
                                        checked={subscription.enableWebhooks}
                                        onChange={() => handleToggleEnabled(index)}
                                    />
                                )}
                            </Col>
                            <Col md={1} className="text-center pl-0">
                                <Button
                                    color="danger"
                                    outline
                                    size="xs"
                                    onClick={() => handleRemoveSubscription(index)}
                                >
                                    X
                                </Button>
                            </Col>
                        </Row>
                    ))}

                    <Row className="">
                        <Col md={12} className="text-left">
                            <Button
                                color="primary"
                                outline
                                size="xs"
                                onClick={handleAddSubscription}
                            >
                                + Add Email
                            </Button>
                        </Col>
                    </Row>
                </Card>
                <Separator className="my-3" />
                <Colxx md="12" className="text-center py-2">
                    <Button
                        color="primary"
                        size="xs"
                        outline
                        onClick={handleSave}
                        disabled={!!loadingSubscriptionId}
                    >
                        Save
                    </Button>
                </Colxx>
            </CardBody>
        </Card>
    );
}